import { render, staticRenderFns } from "./address1.vue?vue&type=template&id=664ec884&scoped=true&"
import script from "./address1.vue?vue&type=script&lang=js&"
export * from "./address1.vue?vue&type=script&lang=js&"
import style0 from "./address1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./address1.vue?vue&type=style&index=1&id=664ec884&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ec884",
  null
  
)

export default component.exports